import actions from './constants';

export const showCatalogueTemplates = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_CATALOGUE_TEMPLATES,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showCatalogueTemplatesError = (category, error) => ({
  type: actions.SHOW_CATALOGUE_TEMPLATES_ERROR,
  category,
  error,
});

export const showCatalogueTemplateSuccess = (category, code, result, intl) => ({
  type: actions.SHOW_CATALOGUE_TEMPLATE_SUCCESS,
  category,
  code,
  result,
  intl,
});

export const showCatalogueTemplateError = (category, code, error) => ({
  type: actions.SHOW_CATALOGUE_TEMPLATE_ERROR,
  category,
  code,
  error,
});

export const showCatalogueTemplateForDataset = (category, code, datasetCode, intl, result) => ({
  type: actions.SHOW_CATALOGUE_TEMPLATE_DATASET_SUCCESS,
  category,
  code,
  datasetCode,
  intl,
  result,
});

export const showCatalogueTemplateDatasetError = (category, code, datasetCode, error) => ({
  type: actions.SHOW_CATALOGUE_TEMPLATE_DATASET_ERROR,
  category,
  code,
  datasetCode,
  error,
});
